<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <board :details="invoiceDetailsBoard" />
    <div class="mt-4">
      <section-title has-line title="Historial de Enmienda" />
      <div
        v-for="(item, index) in history"
        :key="`history-item-${index}`"
        class="row bg-secondary-3 rounded ml-2 mr-0 p-3 mb-2"
      >
        <div class="col border-right d-flex align-items-center">
          <div class="color-black font-16 font-weight-bold">
            {{ item.statusName }}
          </div>
        </div>
        <div class="col">
          <div class="color-gray-6 font-14 font-weight-normal">Fecha:</div>
          <div class="color-black font-weight-normal">
            {{ item.createdDate | date }}
          </div>
        </div>
        <div
          class="col-12 col-md-8 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
        >
          <action-button
            class="outline-success px-2"
            i="fas fa-file-search"
            text="Ver nota de admisión"
            variant="outline-success"
            @click="showNoteAdmission(item.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import {
  getStudentReferralAdmision,
  getAllAdmissionNote,
} from '@/modules/shared/studentreferral.api';

export default {
  name: 'AmendedNoteHistory',
  components: {
    PageHeader,
    Board,
    SectionTitle,
    ActionButton,
  },
  data() {
    return {
      history: [],
      admissionInfo: {},
      from: 'search',
      fromData: {
        reload: true,
      },
    };
  },
  computed: {
    interventionPlanId() {
      return Number(this.$route.params.interventionPlanId);
    },
    admissionId() {
      return Number(this.$route.params.admissionId);
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Historial de Enmienda de Servicio Relacionado Activo',
        routes: [
          'Proveedor',
          'Manejo de Referido ',
          'Nota de Admisión',
          'Historial de Enmienda de Servicio Relacionado Activo ',
        ],
      };
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.go(-1);
          },
        },
      ];
    },
    invoiceDetailsBoard() {
      return [
        [
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: `${this.admissionInfo.studentSieId} - ${this.admissionInfo.fullName}`,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Edad:',
            icon: 'fas fa-calendar-edit',
            data: `${this.admissionInfo.studentAge} años`,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Grado:',
            icon: 'fas fa-calendar-edit',
            data: this.admissionInfo.grade,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Impedimento:',
            icon: 'fas fa-ballot-check',
            data: this.admissionInfo.impediment,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Región:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.region,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Municipio:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.municipality,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Escuela:',
            icon: 'fas fa-graduation-cap',
            data: this.admissionInfo.place,
            cols: 'col-12 col-md-3',
          },
        ],
        [
          {
            label: 'Tipo de Servicio:',
            data: this.admissionInfo.disciplineName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Modalidad:',
            data: this.admissionInfo.modalityTypeName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Duración:',
            data: this.admissionInfo.duration,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Frecuencia:',
            data: this.admissionInfo.frequency,
            cols: 'col-4 col-sm col-12 mt-3',
          },
        ],
      ];
    },
  },
  async created() {
    await Promise.all([this.getAdmissionInfo(), this.getInterventionHistory()]);
  },
  mounted() {
    if (this.$route.params.from) {
      this.from = this.$route.params.from;
      this.fromData = this.$route.params.fromData;
    }
  },
  methods: {
    async getAdmissionInfo() {
      const { data } = await getStudentReferralAdmision(this.admissionId);
      this.admissionInfo = { ...data };
    },
    async getInterventionHistory() {
      const { data } = await getAllAdmissionNote(this.admissionId);
      const indiceFechaMasAntigua = data.reduce(
        (last, curent, index, array) => {
          return new Date(curent.createdDate) <
            new Date(array[last].createdDate)
            ? index
            : last;
        },
        0
      );
      const result = data.map((objeto, indice) => ({
        ...objeto,
        isAmended: indice === indiceFechaMasAntigua,
      }));
      if (result?.length) {
        this.history = result.map((h) => ({
          ...h,
          statusName: !h.isAmended ? 'Enmendado' : 'Sometido',
        }));
      }
    },
    showNoteAdmission(noteId) {
      const isLastNote =
        this.history.length > 0 && this.history[0].id === noteId;

      this.$router.push({
        name: 'admissionNote',
        params: {
          admissionId: this.admissionId,
          isFromHistory: true,
          noteId: noteId,
          isLast: isLastNote,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-view__extended {
  background: transparent !important;
  &:hover {
    color: #2db782 !important;
  }
}
::v-deep.intervention-plan-continer {
  .mobile-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
